import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M15.513 16.956h.409c.958 0 1.72-.436 2.404-1.047 1.739-1.55-2.348-3.12-3.743-3.12m-1.667-8.276q.285-.056.588-.057c1.516 0 2.746 1.12 2.746 2.5s-1.23 2.5-2.746 2.5q-.303 0-.588-.057"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M3.734 13.715c-.982.527-3.558 1.602-1.99 2.947.767.657 1.62 1.127 2.694 1.127h6.124c1.073 0 1.927-.47 2.693-1.127 1.57-1.345-1.007-2.42-1.99-2.947-2.303-1.234-5.227-1.234-7.53 0Zm7.099-7.175a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0Z"
    }, null, -1)
  ]))]))
}
export default { render: render }